import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import type { LogMonitoringStats } from '../types/log-monitoring.types';

type TileConfig = {
  key: keyof LogMonitoringStats['header_tiles'];
  label: string;
  accent?: string;
};

const TILES: TileConfig[] = [
  { key: 'new', label: 'New', accent: 'text-[#2563EB]' },
  { key: 'critical', label: 'Critical', accent: 'text-[#DC2626]' },
  { key: 'security', label: 'Security', accent: 'text-[#D97706]' },
  { key: 'ignored', label: 'Ignored' },
  { key: 'fixed', label: 'Fixed', accent: 'text-[#059669]' },
];

type Props = {
  stats: LogMonitoringStats | undefined;
  isLoading?: boolean;
};

export function LogMonitoringStatsTiles({ stats, isLoading }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {TILES.map((tile) => (
        <div
          key={tile.key}
          className={cn(portalDs.card, portalDs.cardPadding, 'flex flex-col gap-1')}
        >
          <span className={portalDs.filterLabel}>{tile.label}</span>
          <span
            className={cn(
              'text-2xl font-bold tracking-[-0.5px] text-[#0D0F1A]',
              tile.accent,
            )}
          >
            {isLoading ? '—' : (stats?.header_tiles[tile.key] ?? 0)}
          </span>
          <span className={portalDs.caption}>Last 7 days</span>
        </div>
      ))}
    </div>
  );
}
